import { injectable } from 'inversify';
import 'reflect-metadata';
import {
  AGRICULTURE_HUMIDITY_LEVELS,
  AGRICULTURE_HUMIDITY_LEVELS_COLORS,
} from '@@/agriculture/config/cultures.config';

@injectable()
export class AgricultureParametersService {
  getHumidityColor(value: string | number | null) {
    if (!value) return AGRICULTURE_HUMIDITY_LEVELS_COLORS.medium;

    const humidity = Number(value);
    const levels = Object.entries(AGRICULTURE_HUMIDITY_LEVELS) as Array<
      [keyof typeof AGRICULTURE_HUMIDITY_LEVELS, { min: number; max: number }]
    >;

    for (let i = 0; i < levels.length; i++) {
      const [level, { min, max }] = levels[i];

      if (humidity >= min && humidity < max) {
        return AGRICULTURE_HUMIDITY_LEVELS_COLORS[level];
      }
    }
  }

  getTemperatureColor(value: string | number | null) {
    return '#007E3C';
  }
}

export interface IAgricultureParametersService {
  getHumidityColor(value: string | number | null): string;
  getTemperatureColor(value: string | number | null): string;
}
